/* eslint-disable no-unused-vars */
import { useMutation, useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";

import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import { GetServicios } from "../../actions/servicio";
import { GetInsumos } from "../../actions/Insumo";
import { GetPagos } from "../../actions/pagos";
import { GetProfesionales } from "../../actions/profesionales";
import { GoTriangleDown, GoTriangleUp } from "react-icons/go";

import ImagenCerrar from "../../images/cerrar.png";
import login from "../../images/login.jpg";
import style from "../../styles/factura.module.css";
import { useProducto } from "../../actions/Producto";
import GetServicios from "../../actions/servicio";
import { PresupuestoId } from "../../actions/presupuesto";
import { CircleAlert } from "lucide-react";

function ABMFacturas() {
   const [isSearching, setIsSearching] = useState(false);
   var urlFac = process.env.REACT_APP_URL_DIR + "factura";
   var urlPresup = process.env.REACT_APP_URL_DIR + "presupuesto";
   var kl = 0;
   const urlCliente = process.env.REACT_APP_URL_DIR + "cliente";
   const location = useLocation();
   const { state } = location;
   const [facturable, setFacturable] = useState(false);
   const users = GetProfesionales();
   const [selectedFormaPago, setSelectedFormaPago] = useState(1); // o el valor por defecto
   const [servicioSeleccionado, setServicioSeleccionado] = useState(false);
   const [variosClie, setVariosClie] = useState([]);
   const [selectedInsumos, setSelectedInsumos] = useState([]);
   const [input, setInput] = useState({
      id: state ? state.id : 0,
      id_primary: state ? state.id_primary : 0,
      documento: state ? state.documento : 0,
      nombre: state ? state.nombre : "",
      email: state ? state.email : "",
      serv_id: state ? state.serv_id : 0,
      companyId: state ? state.companyId : 0,
      telefono: state ? state.telefono : "",
      cod_status: state ? state.cod_status : "1",
      cod_serv: state ? state.cod_serv : 0,
      presupuesto: state ? state.presupuesto : [],
      netoprod: state ? state.netoprod : 0,
      netoinsumo: state ? state.netoinsumo : 0,
      tipoPago: state ? state.tipoPago : 1,
      usuario: 0,
      observaciones: state ? state.observaciones : "",
   });

   const presupuesto = PresupuestoId(input.id);
   const [servicios, setServicios] = useState([]);
   const servicio = GetServicios();
   const mp = GetInsumos();
   const [insumos, setInsumos] = useState([]);
   const [productos, setProductos] = useState([]);
   const pago = GetPagos();
   const { GetProductos } = useProducto();
   const producto = GetProductos();
   const [pagos, setPagos] = useState(state ? state.pagos : 0);

   useEffect(() => {
      setInsumos(mp);

      if (input.id > 0) {
         setFacturable(true);
      }

      if (presupuesto?.servicios?.length > 0) {
         setServicios(presupuesto.servicios);
         input.cod_serv = presupuesto?.servicios[0]?.id_primary || 0;
         setSelectedFormaPago(presupuesto?.tipoPago || 1);
         setServicioSeleccionado(true);
      } else {
         setServicios(servicio);
      }
      if (presupuesto?.insumos?.length > 0) {
         setInsumos(presupuesto.insumos);
      }
      if (presupuesto?.productos?.length > 0) {
         setProductos(producto);
      }
      if (presupuesto?.cliente && presupuesto.cliente.id > 0) {
         input.presupuesto.cliente.nombre = presupuesto.cliente.nombre || "";
         input.presupuesto.cliente.documento =
            presupuesto.cliente.documento || "";
         input.presupuesto.cliente.email = presupuesto.cliente.email || "";
         input.presupuesto.cliente.telefono =
            presupuesto.cliente.telefono || "";
      }

      setPagos(pago.data || []);

      if (presupuesto?.observaciones) {
         input.observaciones = presupuesto.observaciones || "";
      }
      console.log("useEffect input: ", input);
   }, [presupuesto]);

   var tipoInsu = 1;
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "product";
   const urlSI = process.env.REACT_APP_URL_DIR + "Servins";
   const [factdet, setFactdet] = useState([]);
   const [servins, setServins] = useState([]);
   const [nombre, setName] = useState("");
   const [documento, setDocumento] = useState("");
   const [descto, setDescto] = useState(0);
   const [recargo, setRecargo] = useState(0);
   const [recargoDes, setRecargoDes] = useState("");
   const [adelanto, setAdelanto] = useState(0);
   const [codrecargo, setCodrecargo] = useState(1);
   const [cotDolar, setDolar] = useState(0);
   const [onChange, setOnChange] = useState(false);
   const [verisumo, setVerinsumo] = useState(false);
   const [verproducto, setVerproducto] = useState(true);
   const [insDirect, setInsDirect] = useState([]);
   // var [insumost, setInsumost] = useState(state ? state.insumost : 0);
   const [data, setData] = useState(state ? state.productos : 0);
   var cabecera = "Presupuesto";
   var verproductos = true;
   var verremove = true;
   const cantlineas = 15;
   const [minlinea, setMinLinea] = useState(1);
   const [maxlinea, setMaxLinea] = useState(cantlineas);

   // const [hayError, setHayerror]= useState(false)

   const navigate = useNavigate();
   var totalFactura = 0;
   var totalDscto = 0;
   var totalRecargo = 0;
   var metodo = "POST";
   var btnGrabar = true;
   var totInsumo = 0;
   var lastId = 0; // Ultimo id que mostre
   // Validaciones
   const [nombreError, setNombreError] = useState("");
   const [profesionalError, setProfesionalError] = useState("");
   const [documentoError, setDocumentoError] = useState("");
   const [productoError, setProducto] = useState("");

   function gotoFirst() {
      setMinLinea(0);
      setMaxLinea(cantlineas);
   }

   function gotoNext() {
      setMinLinea(maxlinea + 1);
      setMaxLinea(maxlinea + cantlineas);
   }
   function gotoPrevious() {
      setMinLinea(minlinea - cantlineas);
      setMaxLinea(maxlinea - cantlineas);
   }

   // Mutation Sector

   const { mutate: graboPresup } = useMutation({
      mutationFn: (newPost) => {
         // ✅ Determine method dynamically based on id_primary
         const requestMethod = input.id_primary !== 0 ? "PUT" : "POST";
         const requestUrl =
            input.id_primary !== 0
               ? `${urlPresup}/${input.id_primary}`
               : urlPresup;

         return fetch(requestUrl, {
            method: requestMethod,
            body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json());
      },
      onSuccess: () => {
         window.location.href = "/presupuesto";
      },
      onError: () => {
         alert("Error en datos ingresados");
      },
   });

   const {
      mutate: buscarCli,
      isPendingCli,
      isErrorCli,
   } = useMutation({
      mutationFn: async (documento) => {
         const response = await fetch(`${urlCliente}/?documento=${documento}`, {
            method: "GET",
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         });

         if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
         }

         const data = await response.json();

         if (!data || data.length === 0) {
            throw new Error("Cliente no encontrado");
         }

         return data;
      },
      onSuccess: (cliente) => {
         input.documento = cliente[0].documento;
         input.nombre = cliente[0].nombre;
         input.telefono = cliente[0].telefono;
         input.email = cliente[0].email;
         setDocumento(input.documento);
         setIsSearching(false); // ✅ Reset flag
      },
      onError: (error) => {
         console.log("error: ", error);
         alert("Cliente Nuevo: Por favor ingrese los datos");
         setIsSearching(false); // ✅ Reset flag
      },
   });

   const {
      mutate: buscarCliNombre,
      isPendingClinombre,
      isErrorClinombre,
   } = useMutation({
      mutationFn: (nombre) =>
         fetch(`${urlCliente}/?nombre=${nombre.toLowerCase()}`, {
            method: "GET",
            // body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (cliente) => {
         //
         if (cliente.length > 1) {
            console.log("Cliente encontrado: muchos ", cliente.length);
            setVariosClie(cliente);
            return;
         }
         input.documento = cliente[0].documento;
         input.nombre = cliente[0].nombre;
         input.telefono = cliente[0].telefono;
         input.email = cliente[0].email;
         //
         setDocumento(input.documento);
         //setData(data)
         //window.location.href = "/clientes";
      },
      onError: (error) => {
         console.log("error: ", error);
         alert("Cliente Nuevo: Por favor ingrese los datos");
      },
   });

   const {
      mutate: buscarProdDuo,
      isPending2,
      isError2,
   } = useMutation({
      mutationFn: (nombre) =>
         fetch(`${url}/find/${nombre}`, {
            method: "GET",
            // body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (productosFiltrado) => {
         setProductos(productosFiltrado);
         // //
         //setData(data)
         //window.location.href = "/clientes";
      },
      onError: () => {
         alert("Error");
      },
   });
   const {
      mutate: buscarProd,
      isPending,
      isError,
   } = useMutation({
      mutationFn: (nombre) =>
         fetch(`${url}?nombre=${nombre}`, {
            method: "GET",
            // body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (productosFiltrado) => {
         setProductos(productosFiltrado);
      },
      onError: () => {
         alert("Error");
      },
   });
   // Busco Servicios => Insumos
   const {
      mutate: buscarSI,
      isPending: penSi,
      isError: errSI,
   } = useMutation({
      mutationFn: (id) =>
         fetch(`${urlSI}/${id}`, {
            method: "GET",
            // body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (servins) => {
         console.log("servins: ", servins);
         var sumInsumos = 0;
         for (let index = 0; index < servins.length; index++) {
            sumInsumos +=
               parseFloat(servins[index].insumo.recargoCalculado) *
               parseFloat(servins[index].cantidad);
            var pro = {
               id: 0,
               cantidad: 0,
               precio: 0,
               final: 0,
               tipoinsumo: 1,
            };
            pro.id = servins[index].insumoIdPrimary;
            pro.cantidad = servins[index].cantidad;
            pro.precio = parseFloat(servins[index].insumo.dolar);
            pro.final =
               parseFloat(servins[index].insumo.recargoCalculado) *
               parseFloat(servins[index].cantidad);

            insDirect.push(pro);
         }
         totInsumo = parseFloat(sumInsumos);

         var initialProductLine = {
            id: 9999,
            tipo: 9999,
            descripcion: "Insumos",
            dolar: 0,
            precioLista: 0,
            cant: 1,
            tiposerv: 0,
            esteril: 0,
         };
         initialProductLine.dolar = totInsumo.toFixed(2);
         if (totInsumo > 0) {
            factdet.push(initialProductLine);
         }

         //setData(data)
         //window.location.href = "/clientes";
      },
      onError: () => {
         alert("Error");
      },
   });

   // End Mutation Sector

   if (users) {
      if (users?.message === "Token inválido") {
         return (
            <>
               <div>
                  <br />
                  Por favor vuelva a Logonearse
                  <br />
               </div>
               <Link to={"/login"} className="dLink" title="Login">
                  <img src={login} height="90px" width="90px" alt="" />
               </Link>
               &nbsp;&nbsp;
            </>
         );
      }
   }
   const dollarUSLocale = Intl.NumberFormat("de-DE", {
      minimumIntegerDigits: 1,
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
   });
   // const servicios = GetServicios();

   //  const insumos = GetInsumos();

   // Fin control Accesos
   var factura = {
      cliente: {
         documento: "",
         nombre: "",
         email: "",
         telefono: ",",
      },
      numeroFactura: 0,
      fecha: new Date().toLocaleDateString("en-GB"),
      tipoPago: 1, // leva codigo
      recargo: 0, // %
      recargoImp: 0, // %
      cotizacionDolar: 1260,
      descuento: 0, // en porcentaje
      descuentoImp: 0, // en porcentaje
      observaciones: "",
      total: 0,
      productos: [],
      servicios: [],
      insumos: [],
      adicionales: [],
      adelanto: 0,
      usuario: 0,
      netoprod: 0,
      netoinsumo: 0,
   };

   var initialProductLine = {
      id: 0,
      tipo: 2,
      descripcion: "",
      dolar: 0,
      precioOriginal: 0, //
      precioLista: 0, // precio actual * % de ganancia
      cantidad: 1,
      tiposerv: 0,
      esteril: 0,
   };

   // OBTENGO DATOS DEL PRESUPUESTO

   if (
      presupuesto &&
      presupuesto?.servicios?.length > 0 &&
      factdet.length === 0
   ) {
      if (presupuesto?.servicios[0].id > 0) {
         console.log(
            "OBTENGO DATOS DEL PRESUPUESTO",
            presupuesto,
            factdet.length,
            presupuesto.servicios[0].id
         );
         console.log("presupuesto.observaciones: ", presupuesto.observaciones);

         input.nombre = presupuesto.cliente.nombre;

         input.email = presupuesto.cliente.email;
         input.documento = presupuesto.cliente.documento;
         input.telefono = presupuesto.cliente.telefono;
         input.usuario = presupuesto.user.id_rank;
         input.observaciones = presupuesto.observaciones;
         initialProductLine.id = presupuesto.servicios[0].id;
         initialProductLine.tipo = 1;
         initialProductLine.descripcion = presupuesto.servicios[0].descripcion;
         // initialProductLine.dolar = presupuesto.servicios[0].precio;
         initialProductLine.dolar = presupuesto.total;
         initialProductLine.precioOriginal = presupuesto.servicios[0].dolar;
         initialProductLine.precioLista = presupuesto.servicios[0].precio;
         initialProductLine.esteril = 0;
         initialProductLine.tiposerv = 0;
         setCodrecargo(presupuesto.tipoPago);
         setRecargo(presupuesto.tipoPago);
         setRecargoDes(presupuesto.formaspago.descripcion);
         factdet.push(initialProductLine);
         //
         var sumInsumos = 0;
         factdet.insumos = [];
         for (let i = 0; i < presupuesto.insumos.length; i++) {
            //
            if (presupuesto.insumos[i].presupuestoinsumo.tipoinsumo === 1) {
               sumInsumos +=
                  parseFloat(presupuesto.insumos[i].recargoCalculado) *
                  parseFloat(presupuesto.insumos[i].presupuestoinsumo.cantidad);
               var prodLine22 = {
                  id: 0,
                  tipo: 3,
                  descripcion: "",
                  dolar: 0,
                  cantidad: 1,
                  tipoinsumo: 1,
               };
               prodLine22.id = presupuesto.insumos[i].id;
               prodLine22.descripcion = presupuesto.insumos[i].descripcion;
               prodLine22.dolar =
                  presupuesto.insumos[i].presupuestoinsumo.precioFijo;
               prodLine22.cantidad =
                  presupuesto.insumos[i].presupuestoinsumo.cantidad;
               factdet.insumos.push(prodLine22);
            }
         }

         var prodLine2 = {
            id: 9999,
            tipo: 9999,
            descripcion: "Insumos",
            dolar: 0,
            tiposerv: 0,
            cantidad: 1,
         };
         prodLine2.dolar = parseInt(sumInsumos);
         factdet.push(prodLine2);

         for (let i = 0; i < presupuesto.productos.length; i++) {
            var prodLine3 = {
               id: 0,
               tipo: 2,
               descripcion: "Productos",
               dolar: 0,
               tiposerv: 0,
               cantidad: 1,
               precioOriginal: 0,
            };
            prodLine3.id = presupuesto.productos[i].id;
            prodLine3.descripcion =
               presupuesto.productos[i].descripcion +
               " ^ " +
               presupuesto.productos[i].size +
               " Ø " +
               presupuesto.productos[i].gauge;
            prodLine3.dolar =
               presupuesto.productos[i].presupuestoproducto.precioFijo;
            prodLine3.cantidad =
               presupuesto.productos[i].presupuestoproducto.cantidad;
            prodLine3.precioOriginal = presupuesto.productos[i].valorPesos;

            factdet.push(prodLine3); //robin
         }

         // ahora muestro los insumos agregados
         for (let i = 0; i < presupuesto.insumos.length; i++) {
            //
            if (presupuesto.insumos[i].presupuestoinsumo.tipoinsumo === 2) {
               var prodLine23 = {
                  id: presupuesto.insumos[i].id,
                  tipo: 3,
                  descripcion: presupuesto.insumos[i].descripcion,
                  dolar: presupuesto.insumos[i].presupuestoinsumo.precioFijo,
                  precioLista:
                     presupuesto.insumos[i].presupuestoinsumo.precioFijo,
                  cantidad: presupuesto.insumos[i].presupuestoinsumo.cantidad,
                  tipoinsumo: 2,
                  tiposerv: 0,
                  esteril: 0,
               };
               console.log("prodLine23: ", prodLine23);
               factdet.push(prodLine23);
            }
         }

         for (let i = 0; i < presupuesto.adicionals.length; i++) {
            var prodLine4 = {
               id: 0,
               tipo: 9998,
               descripcion: "Adicionales",
               dolar: 0,
               tiposerv: 0,
               cantidad: 1,
            };
            prodLine4.id = presupuesto.adicionals[i].id;
            prodLine4.descripcion = presupuesto.adicionals[i].descripcion;
            prodLine4.dolar = presupuesto.adicionals[i].precioFijo;
            prodLine4.cantidad = presupuesto.adicionals[i].cantidad;
            factdet.push(prodLine4);
         }
         setDescto(presupuesto.descuento);
         setRecargo(presupuesto.recargo);
         setAdelanto(presupuesto.adelanto);
         //   prodLine2 = {id: 0,tipo: 1,descripcion: "",dolar: 0,cant: 1,};

         //   prodLine2.id =  1
         //   prodLine2.descripcion = "Descuento"
         //   prodLine2.cantidad=presupuesto.descuento
         //   prodLine2.dolar=presupuesto.descuentoimporte

         //   factdet.push(prodLine2);
         //   prodLine2 = {id: 0,tipo: 1,descripcion: "",dolar: 0,cant: 1,};
         //   prodLine2.id =  1
         //   prodLine2.descripcion = "Recargo"
         //   prodLine2.cantidad=presupuesto.recargo
         //   prodLine2.dolar=presupuesto.recargoimporte
         //   factdet.push(prodLine2);
      }
   }

   if (!servicios || !insumos || !productos || !users) {
      return <div>Cargando datos</div>;
   }
   const getDolar = async () => {
      try {
         const response = await fetch(
            "https://api.bluelytics.com.ar/v2/latest"
         ); // Replace with your API endpoint
         if (!response) {
            //
         }
         const dolar = await response.json();
         //
         setDolar(dolar.blue.value_sell);
         //
      } catch (error) {
         // setCotDolar(0);
         //setDolar(0);
      }
   };
   const toggleProducto = async () => {
      setVerproducto(!verproducto);
   };
   const toggleInsumo = async () => {
      setVerinsumo(!verisumo);
   };

   const joyeriaPremium = async () => {
      initialProductLine.id = 9998;
      initialProductLine.tipo = 9998;
      initialProductLine.descripcion = "Joyeria Premium";
      initialProductLine.dolar = 0;
      initialProductLine.precioLista = 0;
      initialProductLine.esteril = 0;
      initialProductLine.tiposerv = 0;
      factdet.push(initialProductLine);
      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   };
   const servicioAdicional = async () => {
      initialProductLine.id = 9997;
      initialProductLine.tipo = 9997;
      initialProductLine.descripcion = "Servicio Adicional";
      initialProductLine.dolar = 0;
      initialProductLine.precioLista = 0;
      initialProductLine.esteril = 0;
      initialProductLine.tiposerv = 0;
      factdet.push(initialProductLine);
      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   };
   const handleCheck = (e, i) => {
      if (factdet[i.i].esteril === 0) {
         factdet[i.i].esteril = 1;
      } else {
         factdet[i.i].esteril = 0;
      }
      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   };
   const handlePrecio = (e, i) => {
      //
      //
      setFacturable(false);
      factdet[i.i].dolar = e.target.value;
      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   };
   const handleCant = (e, i) => {
      //
      //
      setFacturable(false);
      if (parseInt(tipoInsu) === 2 && parseInt(e.target.value) === 0) {
         //
         handleRemove(factdet[i.i].id, factdet[i.i].tipo);
         return;
      }

      factdet[i.i].cantidad = e.target.value;

      if (parseInt(factdet[i.i].tipo) === 2) {
         // Productos
         factdet[i.i].dolar = parseInt(
            factdet[i.i].precioLista * cotDolar * factdet[i.i].cantidad
         );
      }
      if (parseInt(factdet[i.i].tipo) === 3) {
         // Insumos
         console.log(
            "precioLista: ",
            factdet[i.i].precioLista,
            factdet[i.i].cantidad
         );
         factdet[i.i].dolar = factdet[i.i].precioLista * factdet[i.i].cantidad;
      }
      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   };

   const handleRemove = (id, tipo) => {
      var xx = 10000;
      for (let ix = 0; ix < factdet.length; ix++) {
         if (factdet[ix].id === id && factdet[ix].tipo === tipo) {
            xx = ix;
            break;
         }
      }

      if (xx !== 10000) {
         factdet.splice(xx, 1);

         // ✅ Remove from selected insumos if it's an insumo
         if (tipo === 3) {
            removeInsumoSelection(id);
         }
      }

      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   };

   // ✅ Add function to remove insumo selection
   const removeInsumoSelection = (id) => {
      setSelectedInsumos((prev) => prev.filter((item) => item.id !== id));
   };
   function handleInputDscto(e) {
      e.preventDefault();
      setDescto(e.target.value);
      //
      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   }

   function handleServicio(e) {
      e.preventDefault();
      for (let i = 0; i < servicios.length; i++) {
         if (parseInt(servicios[i].id_primary) === parseInt(e.target.value)) {
            state.id = 1;
            input.serv_id = servicios[i].id;
            initialProductLine.id = servicios[i].id;
            initialProductLine.tipo = 1;
            initialProductLine.descripcion = servicios[i].descripcion;
            initialProductLine.dolar = servicios[i].precio;
            initialProductLine.precioOriginal = 0;
            initialProductLine.precioLista = servicios[i].precio;
            initialProductLine.tiposerv = servicios[i].tipo;
            initialProductLine.esteril = 0;

            // setFactdet(...factdet,[initialProductLine])
            factdet.push(initialProductLine);

            buscarSI(e.target.value);

            setServicioSeleccionado(true);

            if (onChange) {
               setOnChange(false);
            } else {
               setOnChange(true);
            }
         }
      }
      // setInput({ cod_serv: e.target.value });
      setInput({
         ...input,
         cod_serv: e.target.value,
      });
      // //
      // //
   }

   function handleSelectProd(id) {
      // e.preventDefault();
      // var ee = document.getElementById("producto");
      // var busco = ee.options[ee.selectedIndex].value;

      // //

      // var busco = e.target.value.split(" ");

      //
      for (let i = 0; i < productos.length; i++) {
         if (productos[i].cod_proveedor === id) {
            if (factdet) {
               for (let indx = 0; indx < factdet.length; indx++) {
                  if (
                     parseInt(factdet[indx].id) === parseInt(productos[i].id)
                  ) {
                     factdet[indx].cantidad += 1;
                     factdet[indx].precioLista = parseFloat(
                        productos[i].valorCalculado
                     );
                     factdet[indx].dolar =
                        parseInt(productos[i].valorCalculado * cotDolar) *
                        factdet[indx].cantidad;
                     if (onChange) {
                        setOnChange(false);
                     } else {
                        setOnChange(true);
                     }
                     return;
                  }
               }
            }
            var initialProductLine = {
               id: 0,
               tipo: 2,
               descripcion: "",
               dolar: 0,
               precioOriginal: 0,
               precioLista: 0, // precio actual
               cantidad: 1,
               esteril: 0,
            };
            initialProductLine.id = productos[i].id;
            initialProductLine.tipo = 2;
            initialProductLine.descripcion =
               productos[i].descripcion +
               " ^ " +
               productos[i].size +
               " Ø " +
               productos[i].gauge;
            initialProductLine.precioOriginal = parseFloat(
               productos[i].dolar * cotDolar
            );
            initialProductLine.precioLista = parseFloat(
               productos[i].valorCalculado
            );
            initialProductLine.dolar = parseInt(
               productos[i].valorCalculado * cotDolar
            );
            initialProductLine.esteril = 0;
            initialProductLine.tiposerv = 0;

            // setFactdet(...factdet,[initialProductLine])
            factdet.push(initialProductLine);

            //
            if (onChange) {
               setOnChange(false);
            } else {
               setOnChange(true);
            }
         }
      }
   }

   function handleSelectFormPago(e) {
      e.preventDefault();
      const selectedId = parseInt(e.target.value); // ✅ Usar el value del option (id)
      //
      for (let i = 0; i < pagos.length; i++) {
         if (pagos[i].id_primary === selectedId) {
            setRecargoDes(pagos[i].descripcion);
            setRecargo(pagos[i].recargo);
            setCodrecargo(pagos[i].id_primary);
            setSelectedFormaPago(selectedId); // ✅ Actualizar el estado del select
            if (onChange) {
               setOnChange(false);
            } else {
               setOnChange(true);
            }
         }
      }
   }
   // function handleSelectInsumos(id) {
   //    // e.preventDefault();

   //    for (let i = 0; i < insumos.length; i++) {
   //       if (insumos[i].id === id) {
   //          var initialProductLine = {
   //             id: 0,
   //             tipo: 3,
   //             descripcion: "",
   //             dolar: 0,
   //             precioLista: 0,
   //             cantidad: 1,
   //             esteril: 0,
   //          };
   //          initialProductLine.id = insumos[i].id;
   //          initialProductLine.descripcion = insumos[i].descripcion;
   //          initialProductLine.dolar = parseInt(insumos[i].dolar);
   //          initialProductLine.precioLista = insumos[i].dolar;
   //          initialProductLine.esteril = 0;
   //          initialProductLine.tiposerv = 0;
   //          // if (tipoInsu===2){
   //          //    initialProductLine.dolar = 0
   //          //    initialProductLine.precioLista = 0
   //          // }
   //          factdet.push(initialProductLine);
   //          if (onChange) {
   //             setOnChange(false);
   //          } else {
   //             setOnChange(true);
   //          }
   //       }
   //    }
   // }
   function handleSelectInsumos(id) {
      for (let i = 0; i < insumos.length; i++) {
         if (insumos[i].id === id) {
            console.log("found insumos: ", insumos[i]);
            // Check if item already exists in factdet
            console.log("handleSelectInsumos: ", factdet);
            const existingIndex = factdet.findIndex(
               (item) => item.id === id && item.tipo === 3
            );

            if (existingIndex !== -1) {
               // Item exists, increase quantity
               factdet[existingIndex].cantidad += 1;
               factdet[existingIndex].dolar =
                  factdet[existingIndex].precioLista *
                  factdet[existingIndex].cantidad;
            } else {
               // Item doesn't exist, add new
               var initialProductLine = {
                  id: id,
                  tipo: 3,
                  descripcion: insumos[i].descripcion,
                  dolar: parseInt(insumos[i].dolar),
                  precioLista: insumos[i].dolar,
                  tipoinsumo: 2,
                  cantidad: 1,
                  esteril: 0,
                  tiposerv: 0,
               };
               factdet.push(initialProductLine);
            }

            // ✅ Update selected insumos state
            setSelectedInsumos((prev) => {
               const existing = prev.find((item) => item.id === id);
               if (existing) {
                  // Increase quantity
                  return prev.map((item) =>
                     item.id === id
                        ? { ...item, quantity: item.quantity + 1 }
                        : item
                  );
               } else {
                  // Add new selected item
                  return [
                     ...prev,
                     {
                        id: id,
                        quantity: 1,
                        descripcion: insumos[i].descripcion,
                     },
                  ];
               }
            });

            if (onChange) {
               setOnChange(false);
            } else {
               setOnChange(true);
            }
            break;
         }
      }
   }
   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
      if (e.target.name === "Documento") {
         setDocumento(e.target.value);
      }
      if (e.target.name === "cliente") {
         buscarCli(e.target.value);
         setVariosClie([]);
         setDocumento("");
      }
      // setErrors(
      //    validate({
      //       ...input,
      //       [e.target.name]: e.target.value,
      //    })
      // );
   }

   function handleInputChange(e) {
      if (e.key === "Enter") {
         // setProductos([])
         if (nombre === "") {
            buscarProd(nombre);
         } else {
            buscarProdDuo(nombre);
         }

         setName("");
      }
   }

   function handleInputChangeCliBlur(e) {
      // ✅ Prevent search if already searching or documento is empty
      if (isSearching || !input.documento || input.documento === "0") {
         return;
      }

      console.log("input.documento: ", input.documento);
      setIsSearching(true); // ✅ Set flag before search
      buscarCli(input.documento);
   }

   function handleInputChangeCli(e) {
      if (e.key === "Enter") {
         if (isSearching || !input.documento || input.documento === "0") {
            return;
         }
         setIsSearching(true);
         buscarCli(input.documento);
         setDocumento("");
      }
   }

   function handleInputChangeCliNombre(e) {
      if (e.key === "Enter") {
         console.log("input.nombre: ", input.nombre);
         buscarCliNombre(input.nombre);
         setName("");
      }
   }
   function handleInputChangeCliNombreBlur(e) {
      console.log("input.nombre: ", input.nombre);
      buscarCliNombre(input.nombre);
      setName("");
   }

   // const handleFact = () => {
   //    let text =
   //       "Desea Facturar el Presupuesto Actual!\nSelecione Aceptar or Cancelar.";
   //    if (confirm(text) == true) {
   //       graboFact(input.id_primary);
   //    }
   // };

   const handleSubmit = () => {
      var hayErr = "N";
      setNombreError("");
      setProfesionalError("");
      setDocumentoError("");
      setProducto("");

      // Controles
      if (parseInt(input.usuario) === 0) {
         setProfesionalError("Debe ingresar un Profesional");
         hayErr = "S";
      }
      if (input.documento === "" || parseInt(input.documento) === 0) {
         setDocumentoError("Debe ingresar un Documento");
         hayErr = "S";
      }
      if (input.nombre === "" || input.nombre === undefined) {
         setNombreError("Debe ingresar Nombre");
         hayErr = "S";
      }
      if (input.email === "" || input.email === undefined) {
         input.email = " ";
      }
      if (factdet.length < 3 && factdet[0].id === 1) {
         setProducto("No ha Ingresado Productos");
         hayErr = "S";
      }

      if (hayErr === "S") {
         console.log(
            "hayerr: ",
            nombreError,
            profesionalError,
            documentoError,
            productoError
         );

         // if (onChange) {
         //    setOnChange(false);
         // } else {
         //    setOnChange(true);
         // }
         // return;
      } else {
         var newDate1 = factura.fecha.split("/");
         const newdate = newDate1[2] + "-" + newDate1[1] + "-" + newDate1[0];
         factura.fecha = newdate;
         factura.observaciones = input.observaciones;
         factura.netoinsumo = 0;
         factura.netoprod = 0;
         for (let i = 0; i < insDirect.length; i++) {
            var pro2 = {
               id: 0,
               cantidad: 0,
               precio: 0,
               tipoinsumo: 1,
            };
            pro2.id = insDirect[i].id;
            pro2.cantidad = parseInt(insDirect[i].cantidad);
            pro2.precio = parseInt(insDirect[i].precio);
            pro2.tipoinsumo = parseInt(insDirect[i].tipoinsumo);
            // factura.netoinsumo += insDirect[i].final;
            factura.insumos.push(pro2);
         }
         if (factdet.insumos) {
            for (let i = 0; i < factdet.insumos.length; i++) {
               var proIns = {
                  id: 0,
                  cantidad: 0,
                  precio: 0,
                  tipoinsumo: 1,
               };
               proIns.id = factdet.insumos[i].id;
               proIns.cantidad = factdet.insumos[i].cantidad;
               proIns.precio = factdet.insumos[i].precio;
               if (factdet.insumos[i].precio === undefined) {
                  proIns.precio = factdet.insumos[i].dolar;
               }
               factura.insumos.push(proIns);
            }
         }

         factura.netoinsumo = 0;
         for (let i = 0; i < factdet.length; i++) {
            if (factdet[i].tipo > 1) {
               factura.netoinsumo += parseFloat(factdet[i].dolar);
            }
         }

         for (let i = 0; i < factdet.length; i++) {
            var pro = {
               id: 0,
               cantidad: 0,
               precio: 0,
               precioOriginal: 0,
               esteril: 0,
               tipoinsumo: 2,
            };
            var adic = {
               descripcion: "",
               cantidad: 0,
               precio: 0,
            };
            pro.id = factdet[i].id;
            pro.cantidad = parseInt(factdet[i].cantidad);
            pro.precio = parseInt(factdet[i].dolar);
            pro.esteril = parseInt(factdet[i].esteril);
            if (factdet[i].tipo === 1) factura.servicios.push(pro);
            if (factdet[i].tipo === 2) {
               factura.netoprod += parseInt(factdet[i].dolar);
               pro.precioOriginal = parseInt(
                  factdet[i].precioOriginal * factdet[i].cantidad
               );
               factura.productos.push(pro);
            }
            // agrego adicionales
            // if (factdet[i].tipo === 3) factura.insumos.push(pro);
            if (factdet[i].tipo === 3) {
               var existingItemIndex = insDirect.findIndex(
                  (item) => item.id === pro.id
               );
               if (existingItemIndex !== -1) {
                  factura.insumos[existingItemIndex].cantidad += pro.cantidad;
                  factura.insumos[existingItemIndex].precio += pro.precio;
               } else {
                  factura.insumos.push(pro);
               }
            }
            // if (factdet[i].tipo === 9999) factura.insumos.push(pro);
            if (factdet[i].tipo === 9998 || factdet[i].tipo === 9997) {
               adic.descripcion = factdet[i].descripcion;
               adic.cantidad = parseInt(factdet[i].cantidad);
               adic.precio = parseInt(factdet[i].dolar);
               factura.adicionales.push(adic);
            }
            if (parseInt(descto) !== 0) {
               factura.descuento = descto;
            }
            if (parseInt(recargo) !== 0) {
               factura.descuento = recargo;
            }
         }
         // Datos Cliente
         factura.cliente.documento = input.documento || "0";
         factura.cliente.nombre = input.nombre || "";
         factura.cliente.email = input.email || "";
         factura.cliente.telefono = input.telefono || "";

         factura.tipoPago = codrecargo;
         factura.recargo = recargo;
         factura.recargoImp = parseInt(totalRecargo);

         factura.descuento = descto;
         factura.descuentoImp = totalDscto;
         factura.adelanto = adelanto;
         factura.total = totalFactura;
         factura.usuario = input.usuario;
         factura.numeroFactura = input.id;
         // factura.netoinsumo = parseInt(factura.netoinsumo);
         factura.cotizacionDolar = parseInt(cotDolar);
         factura.esteril = input.esteril;
         // factura.netoprod = parseInt(factura.netoprod);
         //  factura.cotizacionDolar = parseInt(cotDolar);

         // if (input.id_primary !== 0) {
         //    urlPresup =
         //       process.env.REACT_APP_URL_DIR + `presupuesto/${input.id_primary}`;
         //    metodo = "PUT";
         // } else {
         //    urlPresup = process.env.REACT_APP_URL_DIR + "presupuesto";
         //    metodo = "POST";
         // }

         console.log("input: ", input);
         console.log("factura: ", factura);
         console.log("metodo: ", metodo);
         if (hayErr === "N") {
            graboPresup(factura);
         }
      }
   };

   if (cotDolar === 0) {
      //    //
      getDolar();
      //    //
   }

   //
   //
   // //
   //
   //
   if (data && productos.length === 0) setProductos(data);
   if (producto && productos.length === 0) setProductos(producto);
   if (penSi) return <div>Servicios cargando...</div>;
   if (isPending) return <div>Productos cargando...</div>;

   if (factdet) {
      if (factdet[0]) {
         totalFactura = parseInt(factdet[0].dolar);
      }
      // ERA SOLO PARA TATTOO
      // if (factdet[0]?.tiposerv === 2) {
      //    totalFactura = parseInt(factdet[0].dolar);
      // } else {
      //    factdet.map((data) => {
      //       totalFactura += parseInt(data.dolar);
      //    });
      // }
      if (descto > 0) {
         totalDscto = parseInt((totalFactura * descto) / 100);
         totalFactura = parseInt(totalFactura - (totalFactura * descto) / 100);
      }
      if (recargo > 0) {
         totalRecargo = parseInt((totalFactura * recargo) / 100);
         totalFactura = parseInt(totalFactura + (totalFactura * recargo) / 100);
      }
   }

   //
   if (isPending || isPendingCli) {
      return <div>Cargando datos...</div>;
   }
   if (factdet.length > 0) {
      if (factdet[0].tiposerv === 2) {
         verproductos = false;
         tipoInsu = 2;
      }
   }

   //

   return (
      <>
         <div className={style.container}>
            <div className="bg-white w-90">
               <h1 className="justify-self-center">{cabecera}</h1>
               <br />
               <div className={style.data}>
                  <div className={style.divIzq}>
                     {/* {state.id === 0 ? (
                        <div className={style.divServ}>
                           <span style={{ alignContent: "center" }}>
                              Servicio:
                           </span>
                           &nbsp;
                           <select
                              className={style.selData}
                              name="servicio"
                              id="servicio"
                              onChange={(e) => handleServicio(e)}
                              value={input.cod_serv}
                           >
                              <option value="0">Seleccionar</option>
                              {servicios &&
                                 servicios.map((data) => {
                                    return (
                                       <option
                                          value={data.id_primary}
                                          key={data.id_primary}
                                       >{`${data.descripcion}`}</option>
                                    );
                                 })}
                           </select>
                        </div>
                     ) : null}
                     {state.id !== 0 ? ( */}
                     <div>
                        {/* <div className={style.divServ}>
                              <span>Profesional:</span>&nbsp;
                              <select
                                 className={style.selData}
                                 name="usuario"
                                 id="usuario"
                                 onChange={handleChange}
                                 value={input.usuario}
                              >
                                 <option value="0">Seleccionar</option>
                                 {users &&
                                    users.map((data) => {
                                       return (
                                          <option
                                             selected
                                             value={data.id_rank}
                                             key={data.id_rank}
                                          >{`${data.username}`}</option>
                                       );
                                    })}
                              </select>
                              <p className={style.errormsg}>
                                 {profesionalError}
                              </p>
                           </div> */}
                        <div>
                           <div className={style.cliente}>
                              <table>
                                 <tbody>
                                    <tr>
                                       <td className={style.td1}>Servicio:</td>
                                       <td>
                                          <select
                                             className={style.selData}
                                             name="servicio"
                                             id="servicio"
                                             disabled={servicioSeleccionado} // ✅ Deshabilitar cuando esté seleccionado
                                             onChange={(e) => handleServicio(e)}
                                             value={input.cod_serv}
                                          >
                                             <option value="0">
                                                Seleccionar
                                             </option>
                                             {servicios &&
                                                servicios.map((data) => {
                                                   if (data.tipo === 1) {
                                                      return (
                                                         <option
                                                            value={
                                                               data.id_primary
                                                            }
                                                            key={
                                                               data.id_primary
                                                            }
                                                         >{`${data.descripcion}`}</option>
                                                      );
                                                   }
                                                })}
                                          </select>
                                       </td>
                                    </tr>

                                    <tr>
                                       <td className={style.td1}>
                                          Profesional:
                                       </td>
                                       <td>
                                          <select
                                             className={style.selData}
                                             name="usuario"
                                             id="usuario"
                                             onChange={handleChange}
                                             value={input.usuario}
                                          >
                                             <option value="0">
                                                Seleccionar
                                             </option>
                                             {users &&
                                                users.map((data) => {
                                                   return (
                                                      <option
                                                         selected
                                                         value={data.id_rank}
                                                         key={data.id_rank}
                                                      >{`${data.username}`}</option>
                                                   );
                                                })}
                                          </select>
                                          <p className={style.errormsg}>
                                             {profesionalError}
                                          </p>
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className={style.td1}>Documento:</td>
                                       <td>
                                          <input
                                             onKeyDown={(e) =>
                                                handleInputChangeCli(e)
                                             }
                                             // onBlur={(e) =>
                                             //    handleInputChangeCliBlur(e)
                                             // }
                                             type="text"
                                             className={style.clienteinput}
                                             placeholder="Ingrese documento"
                                             name="documento"
                                             value={input.documento}
                                             onChange={handleChange}
                                             required
                                          />
                                          <span
                                             style={{
                                                marginLeft: "5px",
                                                cursor: "pointer",
                                             }}
                                             title="Buscar"
                                             onClick={() => {
                                                if (
                                                   !input.documento ||
                                                   input.documento === "0"
                                                ) {
                                                   alert(
                                                      "Ingrese un documento primero"
                                                   );
                                                   return;
                                                }
                                                buscarCli(input.documento);
                                             }}
                                          >
                                             <CircleAlert />
                                          </span>

                                          <p className={style.errormsg}>
                                             {documentoError}
                                          </p>
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className={style.td1}>Nombre: </td>
                                       <td>
                                          <input
                                             onKeyDown={(e) =>
                                                handleInputChangeCliNombre(e)
                                             }
                                             // onBlur={(e) =>
                                             //    handleInputChangeCliNombreBlur(
                                             //       e
                                             //    )
                                             // }
                                             type="text"
                                             className={style.clienteinput}
                                             placeholder="Ingrese nombre del Cliente"
                                             name="nombre"
                                             value={input.nombre}
                                             onChange={handleChange}
                                             required
                                          />
                                          <span
                                             style={{
                                                marginLeft: "5px",
                                                cursor: "pointer",
                                             }}
                                             title="Buscar"
                                             onClick={() => {
                                                if (
                                                   !input.nombre ||
                                                   input.nombre === "0"
                                                ) {
                                                   alert(
                                                      "Ingrese un nombre primero"
                                                   );
                                                   return;
                                                }
                                                buscarCliNombre(input.nombre);
                                             }}
                                          >
                                             <CircleAlert />
                                          </span>
                                          <p className={style.errormsg}>
                                             {nombreError}
                                          </p>
                                       </td>
                                    </tr>
                                    {variosClie.length > 1 ? (
                                       <tr
                                          style={{
                                             backgroundColor: "#92f6a1ff",
                                          }}
                                       >
                                          <td className={style.td1}>
                                             Clientes:{" "}
                                          </td>
                                          <td>
                                             <select
                                                className={style.clienteinput}
                                                name="cliente"
                                                onChange={handleChange}
                                                required
                                             >
                                                <option value="">
                                                   Seleccione un cliente
                                                </option>
                                                {variosClie.map((data) => {
                                                   return (
                                                      <option
                                                         value={data.documento}
                                                         key={data.documento}
                                                      >{`${data.documento} ${data.nombre}`}</option>
                                                   );
                                                })}
                                             </select>
                                             <p className={style.errormsg}>
                                                {profesionalError}
                                             </p>
                                          </td>
                                       </tr>
                                    ) : null}
                                    <tr>
                                       <td className={style.td1}>Telefono:</td>
                                       <td>
                                          <input
                                             type="text"
                                             className={style.clienteinput}
                                             placeholder="Ingrese Telefono"
                                             name="telefono"
                                             value={input.telefono}
                                             onChange={handleChange}
                                          />
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className={style.td1}> Correo: </td>
                                       <td className={style.td500}>
                                          <input
                                             type="text"
                                             className={style.clienteinput}
                                             placeholder="Ingrese su email (opcional)"
                                             name="email"
                                             value={input.email}
                                             onChange={handleChange}
                                          />
                                       </td>
                                    </tr>
                                    {verproductos ? (
                                       <tr>
                                          <td className={style.td1}>
                                             {" "}
                                             Productos{" "}
                                          </td>
                                          <td className={style.td1}>
                                             <input
                                                onKeyPress={(e) =>
                                                   handleInputChange(e)
                                                }
                                                onChange={(e) =>
                                                   setName(e.target.value)
                                                }
                                                type="text"
                                                id="search-navbar"
                                                placeholder="Buscar..."
                                                value={nombre}
                                             />
                                             {verproducto ? (
                                                <GoTriangleUp
                                                   onClick={() =>
                                                      toggleProducto()
                                                   }
                                                />
                                             ) : (
                                                <GoTriangleDown
                                                   onClick={() =>
                                                      toggleProducto()
                                                   }
                                                />
                                             )}
                                             <p className={style.errormsg}>
                                                {productoError}
                                             </p>
                                          </td>
                                       </tr>
                                    ) : null}
                                 </tbody>
                              </table>
                           </div>
                        </div>
                        {verproductos ? (
                           <>
                              <div
                                 className={
                                    verproducto
                                       ? style.producto
                                       : style.insumoHide
                                 }
                              >
                                 <table className={style.table1}>
                                    <tr>
                                       <th>Codigo</th>
                                       <th>Descripcion</th>
                                       <th>Stock</th>
                                       <th>Esteril</th>
                                    </tr>
                                    {productos &&
                                       productos.map((data, indx) => {
                                          kl += 1;
                                          if (
                                             kl + 1 >= minlinea &&
                                             kl <= maxlinea
                                          ) {
                                             if (data.stock < 1) {
                                                kl -= 1;

                                                return null;
                                             }
                                             if (data.tipoprod > 1) {
                                                return null;
                                             }
                                             return (
                                                <tr
                                                   key={data.id}
                                                   onClick={() =>
                                                      handleSelectProd(
                                                         data.cod_proveedor
                                                      )
                                                   }
                                                   className={style.trGrid}
                                                >
                                                   <td className={style.td1}>
                                                      {data.cod_proveedor}
                                                   </td>
                                                   <td className={style.td2}>
                                                      {data.descripcion} ^{" "}
                                                      {data.size} Ø {data.gauge}
                                                   </td>
                                                   <td className={style.td4}>
                                                      {data.stock}
                                                   </td>
                                                   <td className={style.td4}>
                                                      {data.esteril}
                                                   </td>
                                                </tr>
                                             );
                                          } else {
                                             return null;
                                          }
                                       })}
                                 </table>
                                 <div className={style.antsig}>
                                    <div>
                                       {maxlinea > cantlineas ? (
                                          <button
                                             className={style.inputBtnNew}
                                             onClick={() => gotoPrevious()}
                                          >
                                             Anterior
                                          </button>
                                       ) : // <p onClick={() => gotoPrevious()}>Anterior</p>
                                       null}
                                    </div>
                                    <div>
                                       {maxlinea < producto?.length ? (
                                          <button
                                             className={style.inputBtnNew}
                                             onClick={() => gotoNext()}
                                          >
                                             Siguiente
                                          </button>
                                       ) : // <p onClick={() => gotoNext()}>Siguiente</p>
                                       null}
                                    </div>
                                 </div>
                              </div>
                           </>
                        ) : null}
                     </div>
                     {/* // ) : null} */}
                     {input.cod_serv > 0 ? (
                        <>
                           {/* <div
                              className={style.titulops}
                              onClick={() => toggleInsumo()}
                           >
                              {" "}
                              Insumo Adicional&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              {verisumo ? <GoTriangleUp /> : <GoTriangleDown />}
                           </div> */}

                           {verproductos ? (
                              <div className={style.divLastBtn}>
                                 <div>
                                    <button
                                       className={style.inputBtnNew}
                                       onClick={() => joyeriaPremium()}
                                    >
                                       Joyeria Premium
                                    </button>
                                 </div>
                                 <div>
                                    <button
                                       className={style.inputBtnNew}
                                       onClick={() => servicioAdicional()}
                                    >
                                       Servicio adicional
                                    </button>
                                 </div>
                                 <div>
                                    <button
                                       className={style.inputBtnNew}
                                       onClick={() => toggleInsumo()}
                                    >
                                       Insumo Adicional
                                    </button>
                                 </div>
                              </div>
                           ) : (
                              <div>
                                 <div className={style.insumosolo}>
                                    <button
                                       className={style.inputBtnNew}
                                       onClick={() => toggleInsumo()}
                                    >
                                       Insumo Adicional
                                    </button>
                                 </div>
                              </div>
                           )}

                           <div
                              // className={style.insumo} id="insumo"
                              className={
                                 verisumo ? style.producto : style.insumoHide
                              }
                           >
                              <div>
                                 <table className={style.table1}>
                                    <tr>
                                       <th>Descripcion</th>
                                       <th>Stock</th>
                                       <th>Seleccionado</th>
                                    </tr>
                                    {insumos?.length > 0 &&
                                       insumos?.map((data) => {
                                          var muestroreg = true;
                                          if (tipoInsu === 3) {
                                             muestroreg = false;
                                          }
                                          const selectedItem =
                                             selectedInsumos.find(
                                                (item) => item.id === data.id
                                             );
                                          const isSelected = !!selectedItem;

                                          if (muestroreg) {
                                             return (
                                                <tr
                                                   key={data.id}
                                                   onClick={() =>
                                                      handleSelectInsumos(
                                                         data.id
                                                      )
                                                   }
                                                   className={style.trGrid}
                                                   style={{
                                                      backgroundColor:
                                                         isSelected
                                                            ? "#e8f5e8"
                                                            : "transparent",
                                                      fontWeight: isSelected
                                                         ? "bold"
                                                         : "normal",
                                                      border: isSelected
                                                         ? "2px solid #4CAF50"
                                                         : "1px solid #ddd",
                                                   }}
                                                >
                                                   <td className={style.td2}>
                                                      {data.descripcion}
                                                   </td>
                                                   <td className={style.td2}>
                                                      {data.stock}
                                                   </td>
                                                   <td className={style.td2}>
                                                      {selectedItem
                                                         ? `Qty: ${selectedItem.quantity}`
                                                         : "-"}
                                                   </td>
                                                </tr>
                                             );
                                          } else {
                                             return null;
                                          }
                                       })}
                                 </table>
                              </div>
                           </div>

                           <div className={style.cliente}>
                              <table>
                                 <tr>
                                    <td className={style.td1}>
                                       Descuentos %:{" "}
                                    </td>
                                    <td>
                                       <input
                                          className={style.clienteinput}
                                          onChange={(e) =>
                                             setDescto(e.target.value)
                                          }
                                          type="text"
                                          id="descuento"
                                          name="descuento"
                                          value={descto}
                                       />
                                    </td>
                                 </tr>
                                 <tr>
                                    <td className={style.td1}>Seña: </td>
                                    <td>
                                       <input
                                          className={style.clienteinput}
                                          onChange={(e) =>
                                             setAdelanto(e.target.value)
                                          }
                                          type="text"
                                          id="adelanto"
                                          name="adelanto"
                                          value={adelanto}
                                       />
                                    </td>
                                 </tr>
                                 <tr>
                                    <td className={style.td1}>
                                       Cambio Dolar:{" "}
                                    </td>
                                    <td>
                                       <input
                                          className={style.clienteinput}
                                          type="text"
                                          onChange={(e) =>
                                             setDolar(e.target.value)
                                          }
                                          id="dolar"
                                          name="dolar"
                                          value={cotDolar}
                                       />
                                    </td>
                                 </tr>
                                 <tr>
                                    <td className={style.td1}>
                                       {" "}
                                       Forma de Pago:{" "}
                                    </td>
                                    <td>
                                       <select
                                          className={style.selData}
                                          name="formapago"
                                          id="formapago"
                                          onChange={(e) =>
                                             handleSelectFormPago(e)
                                          }
                                          value={selectedFormaPago}
                                       >
                                          {pagos &&
                                             pagos.map((dats) => {
                                                return (
                                                   <option
                                                      value={dats.id_primary}
                                                      key={dats.id_primary}
                                                   >{`${dats.descripcion}`}</option>
                                                );
                                             })}
                                       </select>
                                    </td>
                                 </tr>
                              </table>
                           </div>
                           <div>
                              <span>Observaciones : </span>&nbsp;
                              <textarea
                                 className={style.textareaEx}
                                 type="text"
                                 placeholder="Ingrese una observación"
                                 name="observaciones"
                                 id="observaciones"
                                 cols={7}
                                 rows={12}
                                 value={input.observaciones}
                                 onChange={handleChange}
                              />
                           </div>
                        </>
                     ) : null}
                  </div>
                  {input.cod_serv > 0 ? (
                     <div className={style.divDer}>
                        <div>
                           <table className={style.tableSel}>
                              <tr>
                                 <td className={style.titulops} colSpan="4">
                                    Productos Seleccionados
                                 </td>
                              </tr>
                              <tr>
                                 {/* <td className="tdId">Id</td> */}
                                 <th>Descripcion</th>
                                 <th>Cantidad</th>
                                 <th className={style.thCenter}>Precio</th>
                                 {verproductos ? <th>Esteril</th> : null}
                                 <th>##</th>
                              </tr>
                              {factdet &&
                                 factdet.map((data, i) => {
                                    var verregistro = true;
                                    verremove = true;
                                    if (i === 0) verremove = false;
                                    if (data.tipo === 9999) verremove = false;
                                    // if (data.tipoprod === 1) verregistro = true;
                                    if (verregistro) {
                                       return (
                                          <>
                                             <tr
                                                key={i}
                                                className={style.trGrid}
                                             >
                                                {/* <td>{data.id}</td> */}
                                                <td className={style.td1}>
                                                   &nbsp;{data.descripcion}
                                                </td>
                                                {data.descripcion ===
                                                "Insumos" ? (
                                                   <td>&nbsp;</td>
                                                ) : (
                                                   <td className={style.td1}>
                                                      <input
                                                         onChange={(e) =>
                                                            handleCant(e, { i })
                                                         }
                                                         className={style.cant}
                                                         value={data.cantidad}
                                                      />
                                                   </td>
                                                )}
                                                <td className={style.precios}>
                                                   <input
                                                      type="number"
                                                      step="0.01"
                                                      onChange={(e) =>
                                                         handlePrecio(e, { i })
                                                      }
                                                      className={style.importe}
                                                      value={data.dolar}
                                                   />
                                                   {/* {dollarUSLocale.format(
                                                   data.dolar
                                                )} */}
                                                </td>
                                                {/* {parseInt(data.esteril) !== 0 ? ( */}
                                                {parseInt(data.id) !== 9999 &&
                                                parseInt(data.id) !== 1 &&
                                                verproductos ? (
                                                   // <>
                                                   <td
                                                      className={style.thCenter}
                                                   >
                                                      <input
                                                         type="checkbox"
                                                         title="Esteril"
                                                         onChange={(e) =>
                                                            handleCheck(e, {
                                                               i,
                                                            })
                                                         }
                                                      />
                                                   </td>
                                                ) : null}
                                                {verremove ? (
                                                   <td className="tdImg">
                                                      <img
                                                         onClick={() =>
                                                            handleRemove(
                                                               data.id,
                                                               data.tipo
                                                            )
                                                         }
                                                         src={ImagenCerrar}
                                                         height="20px"
                                                         alt=""
                                                      />
                                                   </td>
                                                ) : (
                                                   <td>&nbsp;</td>
                                                )}
                                                &nbsp;&nbsp;&nbsp;
                                             </tr>
                                          </>
                                       );
                                    }
                                 })}
                              <tr>
                                 <td colSpan={5}>
                                    <hr />
                                 </td>
                              </tr>
                              {descto > 0 ? (
                                 <>
                                    <tr>
                                       <td>Descuento</td>
                                       <td>{descto} %</td>
                                       <td className={style.preciosdscto}>
                                          -{dollarUSLocale.format(totalDscto)}
                                       </td>
                                       <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                       <td colSpan={5}>
                                          <hr />
                                       </td>
                                    </tr>
                                 </>
                              ) : null}
                              {recargo > 0 ? (
                                 <>
                                    <tr>
                                       <td>{recargoDes}</td>
                                       <td>{recargo} %</td>
                                       <td className={style.precios}>
                                          {dollarUSLocale.format(totalRecargo)}
                                       </td>
                                       <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                       <td colSpan={5}>
                                          <hr />
                                       </td>
                                    </tr>
                                 </>
                              ) : null}
                              <tr>
                                 <td>Total</td>
                                 <td>&nbsp;</td>
                                 <td className={style.preciosFinal}>
                                    {dollarUSLocale.format(totalFactura)}
                                 </td>
                                 <td colSpan={2}>&nbsp;</td>
                              </tr>
                              {adelanto > 0 ? (
                                 <>
                                    <tr>
                                       <td colSpan={5}>
                                          <hr />
                                       </td>
                                    </tr>
                                    <tr>
                                       <td>Adelanto</td>
                                       <td>&nbsp;</td>
                                       <td className={style.preciosdscto}>
                                          -{dollarUSLocale.format(adelanto)}
                                       </td>
                                       <td colSpan={2}>&nbsp;</td>
                                    </tr>
                                    <tr>
                                       <td colSpan={5}>
                                          <hr />
                                       </td>
                                    </tr>
                                    <tr>
                                       <td>Resta Pagar</td>
                                       <td>&nbsp;</td>
                                       <td className={style.preciosFinal}>
                                          {dollarUSLocale.format(
                                             totalFactura - adelanto
                                          )}
                                       </td>
                                       <td colSpan={2}>&nbsp;</td>
                                    </tr>
                                 </>
                              ) : null}
                              <tr>
                                 <td style={{ textAlign: "center" }}>
                                    {btnGrabar ? (
                                       <button
                                          className={style.inputBtnNew}
                                          onClick={() => handleSubmit()}
                                       >
                                          {state ? "GRABAR" : "AGREGAR"}
                                       </button>
                                    ) : null}
                                 </td>
                                 <td
                                    colSpan={2}
                                    style={{ textAlign: "center" }}
                                 ></td>
                                 <td
                                    colSpan={2}
                                    style={{ textAlign: "center" }}
                                 >
                                    <button
                                       className={style.inputBtnNew}
                                       onClick={() => {
                                          navigate("/presupuesto");
                                       }}
                                    >
                                       VOLVER
                                    </button>
                                 </td>
                              </tr>
                           </table>
                        </div>
                     </div>
                  ) : null}
               </div>
            </div>
         </div>
      </>
   );
}

export default ABMFacturas;
